import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "video-player-ptz-panel" }
const _hoisted_2 = {
  class: "video-player-ptz-panel__controls",
  width: "90",
  height: "90",
  viewBox: "0 0 90 90",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M41.3988 40.4036C41.0963 40.2242 41.0963 39.7837 41.3988 39.6044L44.6371 37.6847C44.9442 37.5027 45.3316 37.7256 45.3316 38.0843V41.9236C45.3316 42.2824 44.9442 42.5053 44.6371 42.3232L41.3988 40.4036Z" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M45 40.5762C47.7992 40.5762 50.0684 42.8604 50.0684 45.6781C50.0684 48.4959 47.7992 50.7801 45 50.7801C42.2008 50.7801 39.9316 48.4959 39.9316 45.6781C39.9316 45.3358 39.6559 45.0583 39.3158 45.0583C38.9757 45.0583 38.7 45.3358 38.7 45.6781C38.7 49.1806 41.5206 52.0199 45 52.0199C48.4794 52.0199 51.3 49.1806 51.3 45.6781C51.3 42.1757 48.4794 39.3364 45 39.3364V40.5762Z"
}, null, -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("rect", {
  x: "33.8",
  y: "33.8",
  width: "22.4",
  height: "22.4",
  rx: "11.2",
  stroke: "currentColor",
  "stroke-opacity": "0.85",
  "stroke-width": "1.6"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("rect", {
  x: "1",
  y: "1",
  width: "88",
  height: "88",
  rx: "44",
  stroke: "currentColor",
  "stroke-width": "2"
}, null, -1)
const _hoisted_8 = {
  class: "video-player-ptz-panel__zoom",
  width: "30",
  height: "90",
  viewBox: "0 0 30 90",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_9 = { class: "video-player-ptz-panel__close-icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NIcon = _resolveComponent("NIcon")!
  const _directive_drag_helper = _resolveDirective("drag-helper")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", _hoisted_2, [
      _createElementVNode("g", {
        class: "video-player-ptz-panel__hover",
        fill: "currentColor",
        "fill-opacity": "0.85",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.resetPosition && _ctx.resetPosition(...args)))
      }, _hoisted_5),
      _hoisted_6,
      _createElementVNode("path", {
        d: "M76.6983 45L73.2318 49.3598C72.8782 49.7841 72.9356 50.4147 73.3598 50.7682C73.7841 51.1218 74.4147 51.0645 74.7682 50.6402L78.7682 45.6402C79.0773 45.2694 79.0773 44.7307 78.7682 44.3598L74.7682 39.3598C74.4147 38.9356 73.7841 38.8782 73.3598 39.2318C72.9356 39.5854 72.8782 40.2159 73.2318 40.6402L76.6983 45Z",
        fill: "currentColor",
        class: "video-player-ptz-panel__hover",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updatePosition(1, 0)))
      }),
      _createElementVNode("path", {
        d: "M13.3017 45L16.7682 49.3598C17.1218 49.7841 17.0644 50.4147 16.6402 50.7682C16.2159 51.1218 15.5853 51.0645 15.2318 50.6402L11.2318 45.6402C10.9227 45.2694 10.9227 44.7307 11.2318 44.3598L15.2318 39.3598C15.5853 38.9356 16.2159 38.8782 16.6402 39.2318C17.0644 39.5854 17.1218 40.2159 16.7682 40.6402L13.3017 45Z",
        fill: "currentColor",
        class: "video-player-ptz-panel__hover",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updatePosition(-1, 0)))
      }),
      _createElementVNode("path", {
        d: "M45 13.3017L40.6402 16.7682C40.2159 17.1218 39.5854 17.0644 39.2318 16.6402C38.8782 16.2159 38.9356 15.5853 39.3598 15.2318L44.3598 11.2318C44.7307 10.9227 45.2694 10.9227 45.6402 11.2318L50.6402 15.2318C51.0645 15.5853 51.1218 16.2159 50.7682 16.6402C50.4147 17.0644 49.7841 17.1218 49.3598 16.7682L45 13.3017Z",
        fill: "currentColor",
        class: "video-player-ptz-panel__hover",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updatePosition(0, 1)))
      }),
      _createElementVNode("path", {
        d: "M45 76.6983L40.6402 73.2318C40.2159 72.8782 39.5854 72.9356 39.2318 73.3598C38.8782 73.7841 38.9356 74.4147 39.3598 74.7682L44.3598 78.7682C44.7307 79.0773 45.2694 79.0773 45.6402 78.7682L50.6402 74.7682C51.0645 74.4147 51.1218 73.7841 50.7682 73.3598C50.4147 72.9356 49.7841 72.8782 49.3598 73.2318L45 76.6983Z",
        fill: "currentColor",
        class: "video-player-ptz-panel__hover",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updatePosition(0, -1)))
      }),
      _createElementVNode("path", {
        d: "M68.5882 68.5882L64.1609 69.0936C63.7209 69.1336 63.3966 69.5227 63.4366 69.9627C63.4766 70.4027 63.8658 70.727 64.3058 70.687L69.3969 70.1213C69.7815 70.0864 70.0863 69.7816 70.1212 69.397L70.6869 64.3059C70.7269 63.8659 70.4026 63.4767 69.9626 63.4367C69.5226 63.3967 69.1335 63.721 69.0935 64.161L68.5882 68.5882Z",
        fill: "currentColor",
        class: "video-player-ptz-panel__hover",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updatePosition(1, -1)))
      }),
      _createElementVNode("path", {
        d: "M21.4119 21.4119L20.9065 25.8391C20.8665 26.2791 20.4774 26.6034 20.0374 26.5634C19.5974 26.5234 19.2731 26.1343 19.3131 25.6943L19.8788 20.6031C19.9138 20.2185 20.2185 19.9138 20.6031 19.8788L25.6942 19.3132C26.1343 19.2731 26.5234 19.5974 26.5634 20.0374C26.6034 20.4774 26.2791 20.8666 25.8391 20.9066L21.4119 21.4119Z",
        fill: "currentColor",
        class: "video-player-ptz-panel__hover",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updatePosition(-1, 1)))
      }),
      _createElementVNode("path", {
        d: "M68.5882 21.4119L64.161 20.9066C63.7209 20.8666 63.3967 20.4774 63.4367 20.0374C63.4767 19.5974 63.8658 19.2731 64.3058 19.3132L69.397 19.8788C69.7816 19.9138 70.0863 20.2185 70.1213 20.6031L70.6869 25.6943C70.7269 26.1343 70.4027 26.5234 69.9627 26.5634C69.5226 26.6034 69.1335 26.2792 69.0935 25.8391L68.5882 21.4119Z",
        fill: "currentColor",
        class: "video-player-ptz-panel__hover",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.updatePosition(1, 1)))
      }),
      _createElementVNode("path", {
        d: "M21.4118 68.5883L20.9065 64.161C20.8665 63.721 20.4774 63.3967 20.0374 63.4367C19.5974 63.4767 19.2731 63.8659 19.3131 64.3059L19.8788 69.397C19.9137 69.7816 20.2185 70.0864 20.6031 70.1213L25.6942 70.687C26.1342 70.727 26.5234 70.4027 26.5634 69.9627C26.6034 69.5227 26.2791 69.1336 25.8391 69.0936L21.4118 68.5883Z",
        fill: "currentColor",
        class: "video-player-ptz-panel__hover",
        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.updatePosition(-1, -1)))
      }),
      _hoisted_7
    ])),
    (_openBlock(), _createElementBlock("svg", _hoisted_8, [
      _createElementVNode("path", {
        d: "M15 2.14282C22.1008 2.14282 27.8572 7.89916 27.8572 15C27.8572 22.1008 22.1008 27.8571 15 27.8571C7.89922 27.8571 2.14288 22.1008 2.14288 15C2.14288 7.89916 7.89922 2.14282 15 2.14282ZM15 4.28568C9.08269 4.28568 4.28574 9.08263 4.28574 15C4.28574 20.9173 9.08269 25.7143 15 25.7143C20.9174 25.7143 25.7143 20.9173 25.7143 15C25.7143 9.08263 20.9174 4.28568 15 4.28568ZM15 8.57139C15.5918 8.57139 16.0715 9.05109 16.0715 9.64282V13.9285H20.3572C20.9489 13.9285 21.4286 14.4082 21.4286 15C21.4286 15.5917 20.9489 16.0714 20.3572 16.0714H16.0715V20.3571C16.0715 20.9488 15.5918 21.4285 15 21.4285C14.4083 21.4285 13.9286 20.9488 13.9286 20.3571V16.0714H9.64288C9.05115 16.0714 8.57145 15.5917 8.57145 15C8.57145 14.4082 9.05115 13.9285 9.64288 13.9285H13.9286V9.64282C13.9286 9.05109 14.4083 8.57139 15 8.57139Z",
        fill: "currentColor",
        class: "video-player-ptz-panel__hover",
        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.updateZoom(1)))
      }),
      _createElementVNode("path", {
        d: "M15 62.1428C22.1008 62.1428 27.8572 67.8992 27.8572 75C27.8572 82.1008 22.1008 87.8571 15 87.8571C7.89922 87.8571 2.14288 82.1008 2.14288 75C2.14288 67.8992 7.89922 62.1428 15 62.1428ZM15 64.2857C9.08269 64.2857 4.28574 69.0826 4.28574 75C4.28574 80.9173 9.08269 85.7142 15 85.7142C20.9174 85.7142 25.7143 80.9173 25.7143 75C25.7143 69.0826 20.9174 64.2857 15 64.2857ZM15 73.9285C15.5918 73.9285 15 73.9285 15.75 73.9285H16.0715H20.3572C20.9489 73.9285 21.4286 74.4082 21.4286 75C21.4286 75.5917 20.9489 76.0714 20.3572 76.0714H16.0715H15.75C15 76.0714 15.5918 76.0714 15 76.0714C14.4083 76.0714 15 76.0714 14.4185 76.0714H13.9286H9.64288C9.05115 76.0714 8.57145 75.5917 8.57145 75C8.57145 74.4082 9.05115 73.9285 9.64288 73.9285H13.9286H14.4185C15 73.9285 14.4083 73.9285 15 73.9285Z",
        fill: "currentColor",
        class: "video-player-ptz-panel__hover",
        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.updateZoom(-1)))
      })
    ])),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_NIcon, {
        name: "vp-close-panel",
        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('close')))
      })
    ])
  ])), [
    [_directive_drag_helper]
  ])
}